export default "__VITE_ASSET__4fd790e6__"